<script>
import { onMounted } from 'vue';
import $ from 'jquery'


export default {
  name: "aide&contact",
  components: {},
  setup() {
    onMounted(() => {
      $(document).ready(function () {
        window.dataLayer = window.dataLayer || [];
        let itemToPush = {};
        let H1 = jQuery('.title--2');
        if (H1.length) {
          itemToPush['pagename'] = H1.text().replace(/["+?!]/g, '').replace(/[#_', ]/g, '_').normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        } else {
          let windowPath = window.location.pathname;
          let updatedPath = windowPath.replace(/["+?!/]/g, '')
            .replace(/[#_', ]/g, '_')
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");

          itemToPush['pagename'] = updatedPath;
        }

        itemToPush['pagetype'] = "aide_contact";
        itemToPush['event'] = "page_load";
        window.dataLayer.push(itemToPush);
      });
    })
  }
}

</script>

<style lang="sass">
  @import ../../common/styles/settings
  @import ../../common/styles/mixins
  @import page--aide-contact
</style>
